import cn from 'classnames';
import type { ReactNode } from 'react';

type P = {
  children: ReactNode;
  className?: string;
};

const PinnedFeedCardLayout = ({ children, className }: P) => (
  <div className={cn('pinned-feed-card-layout', className)}>{children}</div>
);

export default PinnedFeedCardLayout;
